import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const IconButton = ({
  children,
  onClick,
  title,
  color
}) => /*#__PURE__*/React.createElement(S.IconButton, {
  type: "button",
  onClick: onClick,
  title: title,
  color: color
}, children);

IconButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  title: PropTypes.string,
  color: PropTypes.string
};
IconButton.defaultProps = {
  onClick: () => {}
};
export default IconButton;